<ng-container [formGroup]="parentFormGroup">
    @if (!editAttachmentFormGroup) {
        @if (!readonly) {
            <div class="m-form-group">
                <label
                    class="p-inputtext m-input-file m-input-group-w-icon"
                    for="fileInput"
                >
                    <span class="label ml-16">{{ "general.chooseFileOrDragItHere" | translate }}</span>
                    <app-svg-icon icon="upload"> </app-svg-icon>
                    <input
                        id="fileInput"
                        #file
                        (change)="addAttachmentFormsFromInput(file)"
                        multiple
                        type="file"
                    />
                </label>
            </div>
        }
        <!-- Requires overflow -->
        <div
            [ngClass]="['file-drop-zone', attachmentForms.length === 0 ? 'drop-image' : '']"
            (fileDropped)="onFileDropped($event)"
            appFileDragAndDrop
            formGroupName="attachments"
            style="position: relative"
        >
            <div class="file-drop-zone-overlay file-drop-zone-overlay-image"></div>
            @for (attachmentForm of attachmentForms.getControls(); track attachmentForm; let attachmentIndex = $index) {
                <div
                    class="row mt-16"
                    formGroupName="{{ attachmentIndex }}"
                >
                    <div class="col-4">
                        <div class="m-attachment-image-wrapper">
                            <div class="m-attachment-image-actions">
                                @if (!readonly) {
                                    <app-icon-button
                                        (click)="deleteAttachment(attachmentIndex)"
                                        icon="delete"
                                        text="form.delete"
                                    >
                                    </app-icon-button>
                                }
                                @if (attachmentForm.get("url").value) {
                                    <app-icon-button
                                        (click)="downloadAttachment(attachmentForm)"
                                        icon="download"
                                        text="general.download"
                                    >
                                    </app-icon-button>
                                }
                            </div>
                            <img
                                [attr.src]="attachmentForm.get('preview').value | safeHtml"
                                [ngStyle]="{ cursor: attachmentForm.get('isPreviewable').value ? 'pointer' : 'unset' }"
                                (click)="editAttachmentImage(attachmentForm)"
                            />
                        </div>
                    </div>
                    <div class="col-8">
                        <div
                            class="m-form-group row"
                            [ngClass]="{ 'has-error': attachmentForm.get('typeId')?.showErrors }"
                        >
                            <label
                                class="col-4"
                                for="typeId{{ attachmentIndex }}"
                            >
                                {{ "general.type" | translate }}
                            </label>
                            <div class="col-8">
                                <p-select
                                    id="typeId{{ attachmentIndex }}"
                                    #typeInput
                                    [options]="attachmentTypes"
                                    [style]="{ width: '100%' }"
                                    (onChange)="markAttachmentAsEdited(attachmentForm)"
                                    appAutofocus
                                    appendTo="body"
                                    formControlName="typeId"
                                    placeholder="{{ 'attachments.selectType' | translate }}"
                                ></p-select>
                                <app-form-validation
                                    [control]="attachmentForm.get('typeId')"
                                    [input]="typeInput"
                                >
                                </app-form-validation>
                            </div>
                        </div>
                        <div
                            class="m-form-group row"
                            [ngClass]="{ 'has-error': attachmentForm.get('name')?.showErrors }"
                        >
                            <label
                                class="col-4"
                                for="name{{ attachmentIndex }}"
                            >
                                {{ "general.name" | translate }}
                            </label>
                            <div class="col-8">
                                <input
                                    class="p-inputtext"
                                    id="name{{ attachmentIndex }}"
                                    #nameInput
                                    (change)="markAttachmentAsEdited(attachmentForm)"
                                    formControlName="name"
                                    type="text"
                                />
                                <app-form-validation
                                    [control]="attachmentForm.get('name')"
                                    [input]="nameInput"
                                >
                                </app-form-validation>
                            </div>
                        </div>
                        <div
                            class="m-form-group row"
                            [ngClass]="{ 'has-error': attachmentForm.get('description').showErrors }"
                        >
                            <label
                                class="col-4"
                                for="description{{ attachmentIndex }}"
                            >
                                {{ "general.description" | translate }}
                            </label>
                            <div class="col-8">
                                <input
                                    class="p-inputtext"
                                    id="description{{ attachmentIndex }}"
                                    #descriptionInput
                                    (onChange)="markAttachmentAsEdited(attachmentForm)"
                                    formControlName="description"
                                    type="text"
                                />
                                <app-form-validation
                                    [control]="attachmentForm.get('description')"
                                    [input]="descriptionInput"
                                >
                                </app-form-validation>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    } @else {
        <h3>{{ "journal.rotateImage" | translate }}</h3>
        @if (editAttachmentFormGroup) {
            <div class="gallery-edit-image">
                <a
                    class="m-btn m-btn-back"
                    (click)="stopEditingAttachmentImage()"
                    title="Back"
                >
                    {{ "general.return" | translate }}
                </a>
                <div class="row">
                    <div class="col-11 text-center gallery-edit-image-title">
                        <h2>{{ editAttachmentFormGroup.get("name").value }}</h2>
                    </div>
                    <div class="col-11 text-center">
                        <img [attr.src]="editAttachmentFormGroup.get('preview').value | safeHtml" />
                    </div>
                    <div class="col-1">
                        <app-icon-button
                            (click)="rotatePhoto()"
                            icon="rotate-right"
                        ></app-icon-button>
                        <app-icon-button
                            (click)="rotatePhoto(false)"
                            icon="rotate-left"
                        ></app-icon-button>
                    </div>
                </div>
            </div>
        }
    }
</ng-container>
